<template>
  <div>
    <div class="container-fluid px-0">
        <div id="containerMenu" class="expandedMenu w-100" :class="{ 'position-relative': !$store.state.responsive.viewDesktopFilters }">
          <div id="classMenu" :class="{ 'mobileView': !$store.state.responsive.viewDesktopFilters }">
            <div class="sideMenu">
              <side-navigation :collapsed="collapse" :changeCollapse="changeCollapse" />
            </div>
          </div>
          <div id="classBody" :class="{ 'mobileView': !$store.state.responsive.viewDesktopFilters }">
            <div id="header">
              <Header :changeCollapse="changeCollapse" />
            </div>
            <div class="container-fluid">
              <slot />
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Widgets/Header/Header.vue';
import SideNavigation from '../components/Widgets/SideNavigation/SideNavigation.vue';
export default {
  name: "AppLayoutPrivate",
  components: {
    Header,
    SideNavigation,
  },
  watch: {
    '$store.state.responsive.viewDesktopFilters': {
      handler: function (newVal) {
        this.resize(newVal);
      },
      immediate: true
    }
  },
  methods: {
    resize(newValue) {
      if (newValue) {
        this.collapse = false;
        this.$nextTick(() => {
          document.getElementById('containerMenu').classList.remove("collapsedMenu");
          document.getElementById('containerMenu').classList.add("expandedMenu");
        })
      } else {
        this.collapse = true;
        this.$nextTick(() => {
          document.getElementById('containerMenu').classList.remove("expandedMenu");
          document.getElementById('containerMenu').classList.add("collapsedMenu");
        })
      }
    },
    changeCollapse() {
      this.collapse = !this.collapse
      if (this.collapse) {
        document.getElementById('containerMenu').classList.remove("expandedMenu");
        document.getElementById('containerMenu').classList.add("collapsedMenu");
      }
      else {
        document.getElementById('containerMenu').classList.remove("collapsedMenu");
        document.getElementById('containerMenu').classList.add("expandedMenu");
      }
    }
  },
  data() {
    return {
      collapse: !this.$store.state.responsive.viewDesktopFilters,
    }
  },
}
</script>

<style scoped lang="scss">

#header {
  // position: fixed;
  width: 100%;
  max-width: 100%;
  height: 70px;
  max-height: 70px;
  z-index: 100;
  top: 0;
  left: 0;
}

#classMenu.mobileView {
  position: absolute;
  top: 0;
  left: 0;
}
 

#classBody {
  padding: 0;
  width: 100%;
  &.mobileView {
      padding-left: 0;
    }
}

.sideMenu {
  height: 100%;
  margin: 0 auto;
  position: fixed;
  background-color: rgb(51, 51, 48);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

// Si el menú está plegado
.collapsedMenu {
  #header {
    // padding-left: 65px;
  }
  #classMenu {
    padding: 0;
    z-index: 1;

    &.mobileView {
      transition: all .5s ease-in-out;
      left: -250px;

      .sideMenu {
        width: 250px;
        max-width: 250px;
      }
    }
  }

  #classBody {
    padding-left: 65px;
    &.mobileView {
      padding-left: 0;
    }
  }

  .sideMenu {
    width: 65px;
    max-width: 65px;
  }
}

// Si el menú está desplegado
.expandedMenu {
  #header {
    // padding-left: 250px;
  }
  #classMenu {
    padding: 0;
    z-index: 20;

    &.mobileView {
      transition: all .5s ease-in-out;
      left: 0px;
    }
  }

  #classBody {
    padding-left: 250px;
    padding-right: 0;

    &.mobileView {
      padding-left: 0;
    }
  }

  .sideMenu {
    width: 250px;
    max-width: 250px;
  }
}
</style>
